export default {
  data() {
    return {
      selectedMode: '',
    };
  },

  methods: {
    openArchivePurgingModal(mode) {
      this.selectedMode = mode;
      this.toggleArchivePurgingModal(false);
    },

    toggleArchivePurgingModal(isClose) {
      const el = document.getElementById('modal-archive-purging-data');
      if (el && isClose) {
        this.selectedMode = '';
        el.classList.remove('show');
      } else if (el && !isClose) {
        el.classList.add('show');
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form-data/jMixArchivePurging.js